import { ProductType } from '@/lib/graphql/generated/graphql';
import { atom } from 'jotai';

import { hasCouponCodesFileState } from './has-coupon-codes-file.state';
import { productsState } from './products.state';

export const hasDigitalProductsWithoutCouponCodesAtom = atom<boolean>((get) => {
  const products = get(productsState);
  const hasCouponCodesFile = get(hasCouponCodesFileState);

  if (!hasCouponCodesFile) {
    return products.some(
      (product) =>
        product.activeVersion.isSelected &&
        product.activeVersion.productType === ProductType.Coupon
    );
  }

  return false;
});
